import { useEffect, useState } from 'react';
import useSdk from 'helpers/hooks/useSdk';

type AverageRatingsResult = {
  averageRatings: {
    Data?: {
      Products?: {
        RatingsCount?: number;
        AverageValue?: number;
      };
    };
  };
};

const useAverageRatings = (productKey?: string) => {
  const [averageRatings, setAverageRatings] = useState<AverageRatingsResult['averageRatings']['Data']>(undefined);

  const sdk = useSdk();

  useEffect(() => {
    sdk
      .callAction<AverageRatingsResult>({
        actionName: 'feedaty/getAverageRatings',
        payload: { sku: productKey },
      })
      .then(
        (res) => {
          setAverageRatings(res.isError ? undefined : res.data.averageRatings.Data);
        },
        () => {
          setAverageRatings(undefined);
        },
      );
  }, [productKey, sdk]);

  return {
    count: averageRatings?.Products?.RatingsCount || 0,
    rating: averageRatings?.Products?.AverageValue || 0,
  };
};

export default useAverageRatings;
